import React from 'react';
import { CardCarousel } from './CardCarousel';
import { cardSlides } from '../data/content';
export function CardPreview() {
  if (cardSlides.length === 0) return null;
  return <section className="bg-night-panel" data-id="element-47" data-mp="2isb0udl13x16">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-48" data-mp="2iqzvi9bxqh7y">
        <div className="mx-auto max-w-2xl text-center" data-id="element-49" data-mp="2dsohrniirmkg">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-50" data-mp="2dr51hwwv5bio">
            Así se ven las tarjetas
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-51" data-mp="1l63twx195sln">
            Un versículo claro, fácil de leer y listo para llevar contigo.
          </p>
        </div>
        <div className="mt-10" data-id="element-52" data-mp="1v1ygu4cie9u8">
          <CardCarousel data-id="element-53" data-mp="1v0nfscag7g6t" />
        </div>
      </div>
    </section>;
}